export const common = {
  // Navigation
  home: 'Accueil',
  financing: 'Financement',
  inventory: 'Inventaire',
  rentals: 'Location',
  contact: 'Contact',
  
  // Hero Section
  heroTitle: 'Véhicules Commerciaux de Qualité pour Votre Entreprise',
  heroSubtitle: 'Des camions cube aux fourgonnettes cargo, trouvez le véhicule parfait pour faire croître votre entreprise. Échanges, locations et financement flexible disponibles.',
  viewInventory: 'Voir l\'Inventaire',
  rentalOptions: 'Options de Location',
  getFinancing: 'Obtenir du Financement',
  
  // Services
  servicesTitle: 'Nos Services',
  servicesSubtitle: 'Solutions complètes de véhicules commerciaux pour vos besoins d\'entreprise',
  vehicleSales: 'Vente de Véhicules',
  vehicleSalesDesc: 'Camions commerciaux et fourgonnettes cargo usagés de qualité avec inspections détaillées',
  tradeIns: 'Échanges',
  tradeInsDesc: 'Juste valeur marchande pour votre véhicule actuel avec évaluations instantanées',
  rentalsService: 'Location',
  rentalsServiceDesc: 'Options de location à court et long terme pour les besoins temporaires',
  financingService: 'Financement',
  financingServiceDesc: 'Solutions de financement flexibles avec taux et conditions compétitifs',
  
  // Featured Vehicles
  featuredVehicles: 'Véhicules en Vedette',
  featuredVehiclesDesc: 'Véhicules commerciaux de qualité prêts pour votre entreprise',
  manageInventory: 'Gérer l\'Inventaire',
  allVehicles: 'Tous les Véhicules',
  boxTrucks: 'Camions Cube',
  cargoVans: 'Fourgonnettes Cargo',
  reeferTrucks: 'Camions Réfrigérés',
  tailgateTrucks: 'Camions Hayon',
  rampTrucks: 'Camions Rampe',
  viewDetails: 'Voir les Détails',
  viewAllInventory: 'Voir Tout l\'Inventaire',
  
  // Rentals
  flexibleRentals: 'Options de location flexibles',
  flexibleRentalsDesc: 'Choisissez le plan de location qui correspond à vos besoins professionnels',
  dailyRentals: 'Locations quotidiennes',
  dailyRentalsDesc: 'Parfait pour les projets à court terme et les livraisons urgentes',
  weeklyRentals: 'Locations hebdomadaires',
  weeklyRentalsDesc: 'Idéal pour les projets à court terme et les demandes saisonnières',
  monthlyRentals: 'Locations mensuelles',
  monthlyRentalsDesc: 'Meilleur rapport qualité-prix pour les opérations commerciales continues',
  mostPopular: 'Le plus populaire',
  bookDailyRental: 'Réserver une location quotidienne',
  bookWeeklyRental: 'Réserver une location hebdomadaire',
  bookMonthlyRental: 'Réserver une location mensuelle',
  customQuote: 'Besoin d\'une solution de location personnalisée? Nous offrons des conditions flexibles pour les exigences uniques d\'entreprise.',
  contactCustomQuote: 'Contacter pour Devis Personnalisé',
  
  // Features
  comprehensiveInsurance: 'Assurance complète',
  unlimitedKilometers: 'Kilométrage illimité',
  fullFleetOptions: 'Options de flotte complète',
  maintenanceIncluded: 'Entretien inclus',
  fleetManagementSupport: 'Support de gestion de flotte',
  flexibleTerms: 'Conditions flexibles',
  
  // Why Choose Us
  whyChooseUs: 'Pourquoi Nous Choisir',
  whyChooseUsDesc: 'Votre partenaire de confiance pour les solutions de véhicules commerciaux',
  qualityGuaranteed: 'Qualité Garantie',
  qualityGuaranteedDesc: 'Chaque véhicule subit une inspection approfondie et vient avec notre garantie de qualité',
  expertSupport: 'Support Expert',
  expertSupportDesc: 'Notre équipe expérimentée fournit un service personnalisé et un support continu',
  competitivePricing: 'Prix Compétitifs',
  competitivePricingDesc: 'Prix justes et transparents avec options de financement flexibles pour votre budget',
  
  // CTA Section
  readyToFind: 'Prêt à Trouver Votre Prochain Véhicule Commercial?',
  readyToFindDesc: 'Contactez-nous aujourd\'hui pour discuter de vos besoins d\'entreprise et explorer notre inventaire',
  browseInventory: 'Parcourir l\'Inventaire',
  scheduleAppointment: 'Planifier un Rendez-vous',
  
  // Footer
  footerDesc: 'Votre partenaire de confiance pour les véhicules commerciaux de qualité, échanges, locations et solutions de financement.',
  services: 'Services',
  contactInfo: 'Informations de Contact',
  allRightsReserved: 'Tous droits réservés.',
  websiteBuilder: 'Créateur de Site Web',
  
  // Common Actions
  loading: 'Chargement...',
  loadingVehicles: 'Chargement des véhicules...',
  
  // Contact Info
  phone: '514.571.7256',
  email: 'camionjma@gmail.com',
  address: '368 rang du brulee\ncontre coeur QC\nCanada'
};